'use client';

import { tv } from 'tailwind-variants';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Button } from '@/components/ui/button/button.component';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';

const professionalButtonKnowMoreStyles = tv({
  slots: {
    container: ['w-fit text-sm'],
  },
});

export function ProfessionalButtonKnowMore(
  props: React.HTMLAttributes<HTMLButtonElement>,
) {
  const { container } = professionalButtonKnowMoreStyles();

  const { className } = props;

  const goToAboutMeSection = () => {
    const element = document.querySelector('#about') as HTMLElement;
    const offset = 80;

    if (!element) {
      return;
    }

    window.scrollTo({
      top: element.offsetTop - offset,
      behavior: 'smooth',
    });
  };

  return (
    <Button
      data-testid={DataTestIdEnum.PROFESSIONAL_KNOW_MORE_BUTTON}
      variant="text"
      className={container({ className })}
      data-analytics-event={AnalyticsEnum.PROFESSIONAL_PROFILE_CLICK_LEARN_MORE}
      onClick={goToAboutMeSection}
    >
      Saiba mais
    </Button>
  );
}
